// import React, { useState, useEffect } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   TextField,
//   Button,
//   Grid,
//   IconButton,
//   InputAdornment,
//   Typography,
// } from "@mui/material";
// import { Users, CheckCircle, XCircle, Shield, Edit, Eye, Trash, Search } from "lucide-react";
// import "./UserManagement.css";
// import { useUsers } from "../../hooks/user/useUsers";
// import { useDeleteUser } from "../../hooks/user/useDeleteUser";
// import { useAddUser } from "../../hooks/user/useAddUser";
// import { updateUserApi } from "../../apis/userApi";
// import { useOrganizations } from "../../hooks/org/useOrganizations";
// import FormDialog from "../../assets/FormDialog";

// const formatRole = (role = "") =>
//   role
//     .replace(/[_-]/g, " ")
//     .replace(/\b\w/g, (c) => c.toUpperCase());

// // format API user
// const formatUser = (user) => {
//   if (!user) return null;

//   const profile = user.profile || {};
//   const firstName = profile.first_name || user.first_name || "";
//   const middleName = profile.middle_name || user.middle_name || "";
//   const lastName = profile.last_name || user.last_name || "";
//   const fullName =
//     profile.full_name ||
//     `${firstName} ${lastName}`.trim() ||
//     "Unknown User";

//   return {
//     id: user.id,
//     uid: user.uid || "",
//     email: user.email || "",
//     role: user.role || "",
//     role_display: formatRole(user.role || ""),
//     phone_number: user.phone_number || "",
//     organization: user.organization || "",
//     organization_name: user.organization_name || "",
//     is_active: user.is_active ?? true,
//     status_display: user.is_active ? "Active" : "Inactive",
//     first_name: firstName,
//     middle_name: middleName,
//     last_name: lastName,
//     full_name: fullName,
//     address_line_1: profile.address_line_1 || "",
//     city: profile.city || "",
//     state: profile.state || "",
//     country: profile.country || "",
//     postal_code: profile.postal_code || "",
//     created_at: user.created_at || "",
//     projects: user.projects || 0,
//     last_login: user.last_login || "Never",
//     profile_picture: profile.profile_picture || null,
//   };
// };  

// const UserManagement = ({ user }) => {
//   const isProjectAdmin = user?.role === "project_admin";

//   const [filters, setFilters] = useState({
//     search: "",
//     group__name: isProjectAdmin ? "surveyor" : "",
//     is_active: "",
//   });

//   const [entriesPerPage, setEntriesPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [query, setQuery] = useState("");
//   const [activeSearch, setActiveSearch] = useState("");

//   // Pass currentPage & entriesPerPage to the hook
//   const { 
//     users: rawUsers, 
//     pagination,          // ← now we have it
//     loading, 
//     error, 
//     refetch 
//   } = useUsers(
//     filters,
//     currentPage,
//     entriesPerPage,
//     user,
//     true
//   );

//   const [users, setUsers] = useState([]);

//   const [isAddUserOpen, setIsAddUserOpen] = useState(false);
//   const [isEditUserOpen, setIsEditUserOpen] = useState(false);
//   const [isViewUserOpen, setIsViewUserOpen] = useState(false);
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
//   const [userToDelete, setUserToDelete] = useState(null);

//   const { deleteUser } = useDeleteUser();
//   const { addUser } = useAddUser();

//   const { organizations, loading: orgLoading } = useOrganizations(true);
//   const totalCount = pagination?.count || 0;
//   const showingFrom = pagination ? (currentPage - 1) * entriesPerPage + 1 : 1;
//   const showingTo   = pagination ? Math.min(currentPage * entriesPerPage, totalCount) : rawUsers.length;

//   useEffect(() => {
//     if (rawUsers) {
//       setUsers(rawUsers.map(formatUser));
//     }
//   }, [rawUsers]);

//   // Client-side search filtering (on top of server-side filters)
//   const filteredUsers = users.filter((u) => {
//     const search = activeSearch.toLowerCase().trim();
//     if (!search) return true;
//     return (
//       u.email?.toLowerCase().includes(search) ||
//       u.full_name?.toLowerCase().includes(search) ||
//       u.role?.toLowerCase().includes(search)
//     );
//   });

//   const handleSearchCommit = () => {
//     setActiveSearch(query.trim());
//     setCurrentPage(1);           // Reset to page 1 on new search
//     // If your useUsers hook supports search param → add it to filters
//     setFilters(prev => ({ ...prev, search: query.trim() }));
//   };

//   const handleClear = () => {
//     setQuery("");
//     setActiveSearch("");
//     setFilters(prev => ({ ...prev, search: "" }));
//     setCurrentPage(1);
//   };

//   // ── Add/Edit Form Fields ── (unchanged)
//   const baseFields = [
//     {
//       name: "first_name",
//       label: "First Name",
//       type: "text",
//       required: true,
//       gridWidth: 4,
//       group: "Personal Details",
//     },
//     {
//       name: "middle_name",
//       label: "Middle Name",
//       type: "text",
//       gridWidth: 4,
//       group: "Personal Details",
//     },
//     {
//       name: "last_name",
//       label: "Last Name",
//       type: "text",
//       required: true,
//       gridWidth: 4,
//       group: "Personal Details",
//     },
//     {
//         name: "email",
//         label: "Email",
//         type: "email",
//         required: true,
//         gridWidth: 6,
//         group: "Contact Information",
//         validate: (v) => {
//           if (!v) return "Email is required";
//           if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v))
//             return "Please enter a valid email address";
//           return "";
//         },
//       },
//     {
//       name: "phone_number",
//       label: "Mobile Number",
//       type: "text",
//       required: true,
//       gridWidth: 6,
//       group: "Contact Information",
//       validate: (v) => {
//         if (!v) return "Required";
//         if (/\s/.test(v)) return "Spaces not allowed";
//         if (!/^[6-9]\d{9}$/.test(v)) return "Please enter a valid 10-digit Indian mobile number";
//         return "";
//       },
//       inputProps: { maxLength: 10, autoComplete: "off" },
//     },
//    {
//     name: "password",
//     label: "Password",
//     type: "password",
//     required: true,
//     gridWidth: 6,
//     helperText:
//       "Minimum 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character",
//     validate: (v) => {
//       if (!v) return "Password is required";
//       if (v.length < 8) return "Minimum 8 characters";
//       if (!/[A-Z]/.test(v)) return "Must include uppercase letter";
//       if (!/[a-z]/.test(v)) return "Must include lowercase letter";
//       if (!/[0-9]/.test(v)) return "Must include number";
//       if (!/[!@#$%^&*]/.test(v))
//         return "Must include special character";
//       return "";
//     },
//     },
//     {
//     name: "password_confirm",
//     label: "Confirm Password",
//     type: "password",
//     required: true,
//     gridWidth: 6,
//     validate: (v, allValues) => {
//       if (!v) return "Confirm your password";
//       if (v !== allValues.password)
//         return "Passwords do not match";
//       return "";
//     },
//   },
//     {
//       name: "role",
//       label: "Role",
//       type: "select",
//       required: true,
//       gridWidth: 6,
//       group: "Account Details",
//       options: isProjectAdmin
//         ? [{ value: "surveyor", label: "Surveyor" }]
//         : [
//             { value: "", label: "Select Role" },
//             { value: "client_admin", label: "Client Admin" },
//             { value: "project_admin", label: "Project Admin" },
//             { value: "surveyor", label: "Surveyor" },
//           ],
//     },
//     {
//       name: "organization",
//       label: "Organization",
//       type: "select",
//       required: true,
//       gridWidth: 6,
//       group: "Account Details",
//       options: orgLoading
//         ? [{ value: "", label: "Loading..." }]
//         : [{ value: "", label: "Select Organization" }, ...organizations.map((o) => ({ value: o.id, label: o.name }))],
//     },
//     {
//       name: "address_line_1",
//       label: "Address Line 1",
//       type: "multiline",
//       required: true,
//       rows: 3,
//       gridWidth: 12,
//       group: "Address",
//     },
//     { name: "city", label: "City", type: "text", required: true, gridWidth: 6, group: "Address" },
//     { name: "state", label: "State", type: "text", required: true, gridWidth: 6, group: "Address" },
//     { name: "country", label: "Country", type: "text", required: true, gridWidth: 6, group: "Address" },
//     {
//       name: "postal_code",
//       label: "Pincode",
//       type: "text",
//       required: true,
//       gridWidth: 6,
//       group: "Address",
//       validate: (v) => (!/^\d{6}$/.test(v || "") ? "Pincode must be 6 digits" : ""),
//       inputProps: { maxLength: 6 },
//     },
//     {
//       name: "profile_picture",
//       label: "Profile Picture",
//       type: "file",
//       gridWidth: 12,
//       group: "Profile",
//       inputProps: { accept: "image/jpeg,image/jpg,image/png" },
//     },
//   ];

//   const editFields = [
//     {
//       name: "email",
//       label: "Email",
//       type: "email",
//       required: false,          // PATCH doesn't require it
//       gridWidth: 6,
//       group: "Contact Information",
//       validate: (v) => {
//         if (v && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v))
//           return "Please enter a valid email address";
//         return "";
//       },
//     },
//     {
//       name: "phone_number",
//       label: "Mobile Number",
//       type: "text",
//       required: false,
//       gridWidth: 6,
//       group: "Contact Information",
//       validate: (v) => {
//         if (v) {
//           if (/\s/.test(v)) return "Spaces not allowed";
//           if (!/^[6-9]\d{9}$/.test(v)) return "Please enter a valid 10-digit Indian mobile number";
//         }
//         return "";
//       },
//       inputProps: { maxLength: 10 },
//     },
//     {
//       name: "first_name",
//       label: "First Name",
//       type: "text",
//       required: false,
//       gridWidth: 4,
//       group: "Personal Details",
//     },
//     {
//       name: "middle_name",
//       label: "Middle Name",
//       type: "text",
//       required: false,
//       gridWidth: 4,
//       group: "Personal Details",
//     },
//     {
//       name: "last_name",
//       label: "Last Name",
//       type: "text",
//       required: false,
//       gridWidth: 4,
//       group: "Personal Details",
//     },
//     {
//       name: "address_line_1",
//       label: "Address Line 1",
//       type: "multiline",
//       required: false,
//       rows: 3,
//       gridWidth: 12,
//       group: "Address",
//     },
//     {
//       name: "city",
//       label: "City",
//       type: "text",
//       required: false,
//       gridWidth: 6,
//       group: "Address",
//     },
//     {
//       name: "state",
//       label: "State",
//       type: "text",
//       required: false,
//       gridWidth: 6,
//       group: "Address",
//     },
//     {
//       name: "country",
//       label: "Country",
//       type: "text",
//       required: false,
//       gridWidth: 6,
//       group: "Address",
//     },
//     {
//       name: "postal_code",
//       label: "Pincode",
//       type: "text",
//       required: false,
//       gridWidth: 6,
//       group: "Address",
//       validate: (v) => {
//         if (v && !/^\d{6}$/.test(v)) return "Pincode must be 6 digits";
//         return "";
//       },
//       inputProps: { maxLength: 6 },
//     },
//     {
//       name: "profile_picture",
//       label: "Profile Picture",
//       type: "file",
//       gridWidth: 12,
//       group: "Profile",
//       inputProps: { accept: "image/jpeg,image/jpg,image/png" },
//     },
//   ];

//   const viewUserFields = [
//     { name: "full_name", label: "Full Name", type: "text", gridWidth: 12 },

//     { name: "email", label: "Email", type: "text", required: true, gridWidth: 6 },

//     { name: "phone_number", label: "Phone Number", type: "text", required: true, gridWidth: 6 },

//     {
//       name: "role_display",
//       label: "Role",
//       type: "text",
//       required: true,
//       gridWidth: 6,
//     },

//     {
//       name: "organization_name",
//       label: "Organization",
//       type: "text",
//       required: true,
//       gridWidth: 6,
//     },

//     {
//       name: "address_line_1",
//       label: "Address",
//       type: "multiline",
//       rows: 3,
//       required: true,
//       gridWidth: 12,
//     },

//     { name: "city", label: "City", type: "text", required: true, gridWidth: 6 },
//     { name: "state", label: "State", type: "text", required: true, gridWidth: 6 },
//     { name: "country", label: "Country", type: "text", required: true, gridWidth: 6 },
//     { name: "postal_code", label: "Pin Code", type: "text", required: true, gridWidth: 6 },

//     {
//       name: "profile_picture",
//       label: "Profile Picture",
//       type: "image",
//       gridWidth: 12,
//       render: (value) =>
//         value ? (
//           <img
//             src={value}
//             alt="Profile"
//             style={{
//               maxWidth: "180px",
//               maxHeight: "180px",
//               objectFit: "cover",
//               borderRadius: "8px",
//               border: "1px solid #e5e7eb",
//             }}
//           />
//         ) : (
//           <Typography color="text.secondary">
//             No profile picture uploaded
//           </Typography>
//         ),
//     },
//   ];


//   const handleAddUserSubmit = async (data) => {
//     if (data.password !== data.password_confirm) {
//       alert("Passwords do not match!");
//       return;
//     }

//     const formData = new FormData();
//     Object.entries(data).forEach(([key, value]) => {
//       if (key === "profile_picture" && value instanceof File) {
//         formData.append(key, value);
//       } else if (key === "status") {
//         formData.append("is_active", value === "active");
//       } else if (value !== undefined && value !== null) {
//         formData.append(key, value);
//       }
//     });

//     try {
//       await addUser(formData);
//       refetch();
//       setIsAddUserOpen(false);
//     } catch (err) {
//       alert(`Failed to add user: ${err.message || "Unknown error"}`);
//     }
//   };

//   const handleEditUserSubmit = async (data) => {
//     const formData = new FormData();
//     Object.entries(data).forEach(([key, value]) => {
//       if (key === "profile_picture" && value instanceof File) {
//         formData.append(key, value);
//       } else if (key === "status") {
//         formData.append("is_active", value === "active");
//       } else if (value !== undefined && value !== null) {
//         formData.append(key, value);
//       }
//     });

//     try {
//       await updateUserApi(selectedUserId, formData);
//       refetch();
//       setIsEditUserOpen(false);
//     } catch (err) {
//       alert(`Failed to update user: ${err.message || "Unknown error"}`);
//     }
//   };

//   const selectedUser = users.find((u) => u.id === selectedUserId) || {};

//  const editInitialValues = {
//   email: selectedUser.email || "",
//   phone_number: selectedUser.phone_number || "",
//   first_name: selectedUser.first_name || "",
//   middle_name: selectedUser.middle_name || "",
//   last_name: selectedUser.last_name || "",
//   address_line_1: selectedUser.address_line_1 || "",
//   city: selectedUser.city || "",
//   state: selectedUser.state || "",
//   country: selectedUser.country || "",
//   postal_code: selectedUser.postal_code || "",
//   // profile_picture is handled separately via file input
// };

//   return (
//     <form autoComplete="off">
//       <div className="user-management">
//         {/* Summary Cards */}
//         <div className="summary-section">
//           <div className="summary-card summary-card--blue">
//             <div className="summary-card__icon"><Users size={24} color="white" /></div>
//             <div className="summary-card__content">
//               <div className="summary-card__title">Total Users</div>
//               <div className="summary-card__value">{totalCount}</div>
//             </div>
//           </div>
//           <div className="summary-card summary-card--green">
//             <div className="summary-card__icon"><CheckCircle size={24} color="white" /></div>
//             <div className="summary-card__content">
//               <div className="summary-card__title">Active Users</div>
//               <div className="summary-card__value">{filteredUsers.filter(u => u.is_active).length}</div>
//             </div>
//           </div>
//           <div className="summary-card summary-card--teal">
//             <div className="summary-card__icon"><XCircle size={24} color="white" /></div>
//             <div className="summary-card__content">
//               <div className="summary-card__title">Inactive Users</div>
//               <div className="summary-card__value">{filteredUsers.filter(u => !u.is_active).length}</div>
//             </div>
//           </div>
//           <div className="summary-card summary-card--purple">
//             <div className="summary-card__icon"><Shield size={24} color="white" /></div>
//             <div className="summary-card__content">
//               <div className="summary-card__title">Administrators</div>
//               <div className="summary-card__value">{filteredUsers.filter(u => u.role?.toLowerCase() === "admin").length}</div>
//             </div>
//           </div>
//         </div>

//         {/* Controls */}
//         <div className="controls-section">
//           <Grid container spacing={2} alignItems="center">
//             <Grid item xs={12} md={4}>
//               <TextField
//                 fullWidth
//                 placeholder="Name, email, or role"
//                 value={query}
//                 onChange={(e) => setQuery(e.target.value)}
//                 onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), handleSearchCommit())}
//                 autoComplete="off"
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <IconButton size="small" onClick={handleSearchCommit} edge="start">
//                         <Search size={16} color="#94a3b8" />
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                   endAdornment: query && (
//                     <InputAdornment position="end">
//                       <IconButton size="small" onClick={handleClear} edge="end">
//                         <XCircle size={16} />
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <select
//                 name="group__name"
//                 value={filters.group__name}
//                 onChange={(e) => {
//                   setFilters(prev => ({ ...prev, group__name: e.target.value }));
//                   setCurrentPage(1);
//                 }}
//                 className="filter-select"
//                 disabled={isProjectAdmin}
//               >
//                 <option value="">All Roles</option>
//                 <option value="admin">Admin</option>
//                 <option value="client_admin">Client Admin</option>
//                 <option value="project_admin">Project Admin</option>
//                 <option value="surveyor">Surveyor</option>
//               </select>
//             </Grid>

//             {!isProjectAdmin && (
//               <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
//                 <Button
//                   variant="contained"
//                   onClick={() => setIsAddUserOpen(true)}
//                   className="add-user-btn"
//                 >
//                   Add User
//                 </Button>
//               </Grid>
//             )}
//           </Grid>
//         </div>

//         {/* Table */}
//         <div className="table-container">
//           {loading ? (
//             <div className="loading-state">Loading users...</div>
//           ) : error ? (
//             <div className="error-state">Failed to load users. Please try again.</div>
//           ) : (
//             <table className="users-table">
//               <thead>
//                 <tr>
//                   <th>User</th>
//                   <th>Role</th>
//                   <th>Status</th>
//                   <th>Organization</th>
//                   <th>Last Login</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredUsers.map((u) => (
//                   <tr key={u.id}>
//                     <td>
//                       <div className="user-info">
//                         <div className="user-avatar" style={{ backgroundColor: "#3b82f6" }}>
//                           {u.profile_picture ? (
//                             <img src={u.profile_picture} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }} />
//                           ) : (
//                             u.full_name?.slice(0, 2).toUpperCase() || "??"
//                           )}
//                         </div>
//                         <div className="user-details">
//                           <div className="user-name">{u.full_name}</div>
//                           <div className="user-email">{u.email}</div>
//                         </div>
//                       </div>
//                     </td>
//                     <td>{formatRole(u.role)}</td>
//                     <td>{u.is_active ? "Active" : "Inactive"}</td>
//                     <td>{u.organization_name || 'N/A'}</td>
//                     <td>{u.last_login}</td>
//                     <td>
//                       <IconButton onClick={() => { setSelectedUserId(u.id); setIsEditUserOpen(true); }}>
//                         <Edit size={20} color="#10b981" />
//                       </IconButton>
//                       <IconButton onClick={() => { setSelectedUserId(u.id); setIsViewUserOpen(true); }}>
//                         <Eye size={20} color="#06b6d4" />
//                       </IconButton>
//                       <IconButton onClick={() => { setUserToDelete(u.id); setIsDeleteDialogOpen(true); }}>
//                         <Trash size={20} color="red" />
//                       </IconButton>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </div>

//        {/* Pagination + Rows per page – using classes from your CSS */}
//         {totalCount > 0 && (
//           <div className="pagination-section">
//             <div className="pagination-info">
//               Showing {showingFrom} – {showingTo} of {totalCount}
//             </div>

//             <div className="pagination-controls">
//               {/* Rows per page selector */}
//               <select
//                 className="page-size-select"
//                 value={entriesPerPage}
//                 onChange={(e) => {
//                   setEntriesPerPage(Number(e.target.value));
//                   setCurrentPage(1);           // reset to first page
//                 }}
//               >
//                 <option value={10}>10</option>
//                 <option value={15}>15</option>
//                 <option value={20}>20</option>
//                 <option value={25}>25</option>
//                 <option value={50}>50</option>
//                 <option value={100}>100</option>
//               </select>

//               {/* Navigation buttons */}
//               <button
//                 className="pagination-btn"
//                 disabled={currentPage === 1 || loading}
//                 onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
//               >
//                 Previous
//               </button>

//               <button
//                 className="pagination-btn"
//                 disabled={currentPage >= (pagination?.total_pages || 1) || loading}
//                 onClick={() => setCurrentPage((p) => p + 1)}
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Dialogs */}
//         {!isProjectAdmin && (
//           <FormDialog
//             open={isAddUserOpen}
//             onClose={() => setIsAddUserOpen(false)}
//             title="Add New User"
//             fields={baseFields}
//             initialValues={{ status: "active" }}
//             onSubmit={handleAddUserSubmit}
//             submitLabel="Create User"
//           />
//         )}

//         <FormDialog
//           open={isEditUserOpen}
//           onClose={() => setIsEditUserOpen(false)}
//           title="Edit User"
//           fields={editFields}
//           initialValues={editInitialValues}
//           onSubmit={handleEditUserSubmit}
//           profileImage={selectedUser.profile_picture}
//           profileName={selectedUser.full_name}
//           showProfileEdit={false}
//           editMode={true}
//         />

//          <FormDialog
//             open={isViewUserOpen}
//             onClose={() => setIsViewUserOpen(false)}
//             title="User Details"
//             fields={viewUserFields}
//             initialValues={selectedUser}
//             viewMode
//             submitLabel="Close"
//             cancelLabel="Close"
//             profileImage={selectedUser.profile_picture}
//             profileName={selectedUser.full_name}
//           />

//         <Dialog open={isDeleteDialogOpen} onClose={() => setIsDeleteDialogOpen(false)}>
//           <DialogTitle>Confirm Delete</DialogTitle>
//           <DialogContent>
//             <DialogContentText>
//               Are you sure you want to delete this user? This action cannot be undone.
//             </DialogContentText>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setIsDeleteDialogOpen(false)}>Cancel</Button>
//             <Button
//               color="error"
//               onClick={async () => {
//                 try {
//                   await deleteUser(userToDelete);
//                   refetch();
//                   setIsDeleteDialogOpen(false);
//                 } catch (err) {
//                   alert("Delete failed");
//                 }
//               }}
//             >
//               Delete
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </div>
//     </form>
//   );
// };

// export default UserManagement;


import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { Users, CheckCircle, XCircle, Shield, Edit, Eye, Trash, Search } from "lucide-react";
import "./UserManagement.css";
import { useUsers } from "../../hooks/user/useUsers";
import { useDeleteUser } from "../../hooks/user/useDeleteUser";
import { useAddUser } from "../../hooks/user/useAddUser";
import { updateUserApi } from "../../apis/userApi";
import { useOrganizations } from "../../hooks/org/useOrganizations";
import FormDialog from "../../assets/FormDialog";

const formatRole = (role = "") =>
  role
    .replace(/[_-]/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

// format API user
const formatUser = (user) => {
  if (!user) return null;
  const profile = user.profile || {};
  const firstName = profile.first_name || user.first_name || "";
  const middleName = profile.middle_name || user.middle_name || "";
  const lastName = profile.last_name || user.last_name || "";
  const fullName =
    profile.full_name ||
    `${firstName} ${lastName}`.trim() ||
    "Unknown User";
  return {
    id: user.id,
    uid: user.uid || "",
    email: user.email || "",
    role: user.role || "",
    role_display: formatRole(user.role || ""),
    phone_number: user.phone_number || "",
    organization: user.organization || "",
    organization_name: user.organization_name || "",
    is_active: user.is_active ?? true,
    status_display: user.is_active ? "Active" : "Inactive",
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
    full_name: fullName,
    address_line_1: profile.address_line_1 || "",
    city: profile.city || "",
    state: profile.state || "",
    country: profile.country || "",
    postal_code: profile.postal_code || "",
    created_at: user.created_at || "",
    projects: user.projects || 0,
    last_login: user.last_login || "Never",
    profile_picture: profile.profile_picture || null,
  };
};

const UserManagement = ({ user }) => {
  const isProjectAdmin = user?.role === "surveyor";
  const [filters, setFilters] = useState({
    search: "",
    group__name: isProjectAdmin ? "surveyor" : "",
    is_active: "",
  });
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");
  const [activeSearch, setActiveSearch] = useState("");
  // Pass currentPage & entriesPerPage to the hook
  const {
    users: rawUsers,
    pagination, // ← now we have it
    loading,
    error,
    refetch
  } = useUsers(
    filters,
    currentPage,
    entriesPerPage,
    user,
    true
  );
  const [users, setUsers] = useState([]);
  const [isAddUserOpen, setIsAddUserOpen] = useState(false);
  const [isEditUserOpen, setIsEditUserOpen] = useState(false);
  const [isViewUserOpen, setIsViewUserOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const { deleteUser } = useDeleteUser();
  const { addUser } = useAddUser();
  const { organizations, loading: orgLoading } = useOrganizations(true);
  const totalCount = pagination?.count || 0;
  const showingFrom = pagination ? (currentPage - 1) * entriesPerPage + 1 : 1;
  const showingTo = pagination ? Math.min(currentPage * entriesPerPage, totalCount) : rawUsers.length;
  useEffect(() => {
    if (rawUsers) {
      setUsers(rawUsers.map(formatUser));
    }
  }, [rawUsers]);
  // Client-side search filtering (on top of server-side filters)
  const filteredUsers = users;



  
  const handleSearchCommit = () => {
    setActiveSearch(query.trim());
    setCurrentPage(1); // Reset to page 1 on new search
    // If your useUsers hook supports search param → add it to filters
    setFilters(prev => ({ ...prev, search: query.trim() }));
  };
  const handleClear = () => {
    setQuery("");
    setActiveSearch("");
    setFilters(prev => ({ ...prev, search: "" }));
    setCurrentPage(1);
  };
  // ── Add/Edit Form Fields ── (unchanged)
  const baseFields = [
    {
      name: "first_name",
      label: "First Name",
      type: "text",
      required: true,
      gridWidth: 4,
      group: "Personal Details",
    },
    {
      name: "middle_name",
      label: "Middle Name",
      type: "text",
      gridWidth: 4,
      group: "Personal Details",
    },
    {
      name: "last_name",
      label: "Last Name",
      type: "text",
      required: true,
      gridWidth: 4,
      group: "Personal Details",
    },
    {
        name: "email",
        label: "Email",
        type: "email",
        required: true,
        gridWidth: 6,
        group: "Contact Information",
        validate: (v) => {
          if (!v) return "Email is required";
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v))
            return "Please enter a valid email address";
          return "";
        },
      },
    {
      name: "phone_number",
      label: "Mobile Number",
      type: "text",
      required: true,
      gridWidth: 6,
      group: "Contact Information",
      validate: (v) => {
        if (!v) return "Required";
        if (/\s/.test(v)) return "Spaces not allowed";
        if (!/^[6-9]\d{9}$/.test(v)) return "Please enter a valid 10-digit Indian mobile number";
        return "";
      },
      inputProps: { maxLength: 10, autoComplete: "off" },
    },
    {
      name: "password",
      label: "Password",
      type: "password",
      required: true,
      gridWidth: 6,
      group: "Credentials",
      inputProps: { autoComplete: "new-password" },
      helperText: "Password must be at least 8 characters long, contain uppercase, lowercase, number, and special character.",
      validate: (v, allValues) => {
        if (!v) return "Password is required";
        if (v.length < 8) return "Password must be at least 8 characters long";
        if (!/(?=.*[a-z])/.test(v)) return "Must contain at least one lowercase letter";
        if (!/(?=.*[A-Z])/.test(v)) return "Must contain at least one uppercase letter";
        if (!/(?=.*\d)/.test(v)) return "Must contain at least one number";
        if (!/(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])/.test(v)) return "Must contain at least one special character";
        return "";
      },
    },
    {
      name: "password_confirm",
      label: "Confirm Password",
      type: "password",
      required: true,
      gridWidth: 6,
      group: "Credentials",
      validate: (v, allValues) => (v !== allValues.password ? "Passwords do not match" : ""),
      inputProps: { autoComplete: "new-password" },
    },
    {
      name: "role",
      label: "Role",
      type: "select",
      required: true,
      gridWidth: 6,
      group: "Account Details",
      options: isProjectAdmin
        ? [{ value: "surveyor", label: "Surveyor" }]
        : [
            { value: "", label: "Select Role" },
            { value: "client_admin", label: "Client Admin" },
            { value: "project_admin", label: "Project Admin" },
            { value: "surveyor", label: "Surveyor" },
          ],
    },
    {
      name: "organization",
      label: "Organization",
      type: "select",
      required: true,
      gridWidth: 6,
      group: "Account Details",
      options: orgLoading
        ? [{ value: "", label: "Loading..." }]
        : [{ value: "", label: "Select Organization" }, ...organizations.map((o) => ({ value: o.id, label: o.name }))],
    },
    {
      name: "address_line_1",
      label: "Address Line 1",
      type: "multiline",
      required: true,
      rows: 3,
      gridWidth: 12,
      group: "Address",
    },
    { name: "city", label: "City", type: "text", required: true, gridWidth: 6, group: "Address" },
    { name: "state", label: "State", type: "text", required: true, gridWidth: 6, group: "Address" },
    { name: "country", label: "Country", type: "text", required: true, gridWidth: 6, group: "Address" },
    {
      name: "postal_code",
      label: "Pincode",
      type: "text",
      required: true,
      gridWidth: 6,
      group: "Address",
      validate: (v) => (!/^\d{6}$/.test(v || "") ? "Pincode must be 6 digits" : ""),
      inputProps: { maxLength: 6 },
    },
    {
      name: "profile_picture",
      label: "Profile Picture",
      type: "file",
      gridWidth: 12,
      group: "Profile",
      inputProps: { accept: "image/jpeg,image/jpg,image/png" },
      validate: (v) => {
        if (!v) return ""; // Optional for create/edit
        if (v instanceof File) {
          const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
          if (!allowedTypes.includes(v.type)) {
            return "Only JPEG, JPG, or PNG images are allowed.";
          }
          if (v.size > 5 * 1024 * 1024) { // 5MB limit
            return "File size must be less than 5MB.";
          }
        }
        return "";
      },
    },
  ];
  const editFields = [
    {
      name: "email",
      label: "Email",
      type: "email",
      required: false, // PATCH doesn't require it
      gridWidth: 6,
      group: "Contact Information",
      validate: (v) => {
        if (v && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v))
          return "Please enter a valid email address";
        return "";
      },
    },
    {
      name: "phone_number",
      label: "Mobile Number",
      type: "text",
      required: false,
      gridWidth: 6,
      group: "Contact Information",
      validate: (v) => {
        if (v) {
          if (/\s/.test(v)) return "Spaces not allowed";
          if (!/^[6-9]\d{9}$/.test(v)) return "Please enter a valid 10-digit Indian mobile number";
        }
        return "";
      },
      inputProps: { maxLength: 10 },
    },
    {
      name: "first_name",
      label: "First Name",
      type: "text",
      required: false,
      gridWidth: 4,
      group: "Personal Details",
    },
    {
      name: "middle_name",
      label: "Middle Name",
      type: "text",
      required: false,
      gridWidth: 4,
      group: "Personal Details",
    },
    {
      name: "last_name",
      label: "Last Name",
      type: "text",
      required: false,
      gridWidth: 4,
      group: "Personal Details",
    },
    {
      name: "address_line_1",
      label: "Address Line 1",
      type: "multiline",
      required: false,
      rows: 3,
      gridWidth: 12,
      group: "Address",
    },
    {
      name: "city",
      label: "City",
      type: "text",
      required: false,
      gridWidth: 6,
      group: "Address",
    },
    {
      name: "state",
      label: "State",
      type: "text",
      required: false,
      gridWidth: 6,
      group: "Address",
    },
    {
      name: "country",
      label: "Country",
      type: "text",
      required: false,
      gridWidth: 6,
      group: "Address",
    },
    {
      name: "postal_code",
      label: "Pincode",
      type: "text",
      required: false,
      gridWidth: 6,
      group: "Address",
      validate: (v) => {
        if (v && !/^\d{6}$/.test(v)) return "Pincode must be 6 digits";
        return "";
      },
      inputProps: { maxLength: 6 },
    },
    {
      name: "profile_picture",
      label: "Profile Picture",
      type: "file",
      gridWidth: 12,
      group: "Profile",
      inputProps: { accept: "image/jpeg,image/jpg,image/png" },
      validate: (v) => {
        if (!v) return ""; // Optional for create/edit
        if (v instanceof File) {
          const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
          if (!allowedTypes.includes(v.type)) {
            return "Only JPEG, JPG, or PNG images are allowed.";
          }
          if (v.size > 5 * 1024 * 1024) { // 5MB limit
            return "File size must be less than 5MB.";
          }
        }
        return "";
      },
    },
  ];
  const viewUserFields = [
    { name: "full_name", label: "Full Name", type: "text", gridWidth: 12 },
    { name: "email", label: "Email", type: "text", required: true, gridWidth: 6 },
    { name: "phone_number", label: "Phone Number", type: "text", required: true, gridWidth: 6 },
    {
      name: "role_display",
      label: "Role",
      type: "text",
      required: true,
      gridWidth: 6,
    },
    {
      name: "organization_name",
      label: "Organization",
      type: "text",
      required: true,
      gridWidth: 6,
    },
    {
      name: "address_line_1",
      label: "Address",
      type: "multiline",
      rows: 3,
      required: true,
      gridWidth: 12,
    },
    { name: "city", label: "City", type: "text", required: true, gridWidth: 6 },
    { name: "state", label: "State", type: "text", required: true, gridWidth: 6 },
    { name: "country", label: "Country", type: "text", required: true, gridWidth: 6 },
    { name: "postal_code", label: "Pin Code", type: "text", required: true, gridWidth: 6 },
    {
      name: "profile_picture",
      label: "Profile Picture",
      type: "image",
      gridWidth: 12,
      render: (value) =>
        value ? (
          <img
            src={value}
            alt="Profile"
            style={{
              maxWidth: "180px",
              maxHeight: "180px",
              objectFit: "cover",
              borderRadius: "8px",
              border: "1px solid #e5e7eb",
            }}
          />
        ) : (
          <Typography color="text.secondary">
            No profile picture uploaded
          </Typography>
        ),
    },
  ];
  const handleAddUserSubmit = async (data) => {
    if (data.password !== data.password_confirm) {
      // alert("Passwords do not match!");
      return;
    }
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (key === "profile_picture" && value instanceof File) {
        formData.append(key, value);
      } else if (key === "status") {
        formData.append("is_active", value === "active");
      } else if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    try {
      await addUser(formData);
      refetch();
      setIsAddUserOpen(false);
    } catch (err) {
      // alert(`Failed to add user: ${err.message || "Unknown error"}`);
    }
  };
 const handleEditUserSubmit = async (data, initialValues = {}) => { // Pass initialValues for diff
  const formData = new FormData();
  let hasChanges = false;

  Object.entries(data).forEach(([key, value]) => {
    // Skip if unchanged or empty (PATCH best practice)
    const initialVal = initialValues[key] || '';
    if (key === "profile_picture" && value instanceof File) {
      formData.append(key, value);
      hasChanges = true;
    } else if (key === "status") {
      const isActive = value === "active";
      if (isActive !== initialVal) {
        formData.append("is_active", isActive);
        hasChanges = true;
      }
    } else if (value !== undefined && value !== null && value !== "" && value !== initialVal) {
      formData.append(key, value);
      hasChanges = true;
    }
  });

  if (!hasChanges) {
    console.log("No changes detected - skipping update");
    // alert("No changes made.");
    return;
  }

  try {
    console.log("Sending PATCH data:", Object.fromEntries(formData)); // Debug: Log payload
    await updateUserApi(selectedUserId, formData);
    refetch();
    setIsEditUserOpen(false);
  } catch (err) {
    console.error("Edit error:", err); // Debug: Log full error
    const msg = err.response?.data?.detail || err.message || "Unknown error";
    if (msg.includes("permission") || msg.includes("restricted")) {
      // alert(`Update failed: Permission denied for field(s). Check role restrictions.`);
    } else {
      // alert(`Failed to update user: ${msg}`);
    }
  }
};
  const selectedUser = users.find((u) => u.id === selectedUserId) || {};
 const editInitialValues = {
  email: selectedUser.email || "",
  phone_number: selectedUser.phone_number || "",
  first_name: selectedUser.first_name || "",
  middle_name: selectedUser.middle_name || "",
  last_name: selectedUser.last_name || "",
  address_line_1: selectedUser.address_line_1 || "",
  city: selectedUser.city || "",
  state: selectedUser.state || "",
  country: selectedUser.country || "",
  postal_code: selectedUser.postal_code || "",
  // profile_picture is handled separately via file input
};
  return (
    <form autoComplete="off">
      <div className="user-management">
        {/* Summary Cards */}
        <div className="summary-section">
          <div className="summary-card summary-card--blue">
            <div className="summary-card__icon"><Users size={24} color="white" /></div>
            <div className="summary-card__content">
              <div className="summary-card__title">Total Users</div>
              <div className="summary-card__value">{totalCount}</div>
            </div>
          </div>
          <div className="summary-card summary-card--green">
            <div className="summary-card__icon"><CheckCircle size={24} color="white" /></div>
            <div className="summary-card__content">
              <div className="summary-card__title">Active Users</div>
              <div className="summary-card__value">{filteredUsers.filter(u => u.is_active).length}</div>
            </div>
          </div>
          <div className="summary-card summary-card--teal">
            <div className="summary-card__icon"><XCircle size={24} color="white" /></div>
            <div className="summary-card__content">
              <div className="summary-card__title">Inactive Users</div>
              <div className="summary-card__value">{filteredUsers.filter(u => !u.is_active).length}</div>
            </div>
          </div>
          <div className="summary-card summary-card--purple">
            <div className="summary-card__icon"><Shield size={24} color="white" /></div>
            <div className="summary-card__content">
              <div className="summary-card__title">Administrators</div>
              <div className="summary-card__value">{filteredUsers.filter(u => u.role?.toLowerCase() === "admin").length}</div>
            </div>
          </div>
        </div>
        {/* Controls */}
        <div className="controls-section">
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                placeholder="Name, email, or role"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), handleSearchCommit())}
                autoComplete="off"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton size="small" onClick={handleSearchCommit} edge="start">
                        <Search size={16} color="#94a3b8" />
                      </IconButton>
                    </InputAdornment>
                  ),
                  endAdornment: query && (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={handleClear} edge="end">
                        <XCircle size={16} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <select
                name="group__name"
                value={filters.group__name}
                onChange={(e) => {
                  setFilters(prev => ({ ...prev, group__name: e.target.value }));
                  setCurrentPage(1);
                }}
                className="filter-select"
                disabled={isProjectAdmin}
              >
                <option value="">All Roles</option>
                <option value="admin">Admin</option>
                <option value="client_admin">Client Admin</option>
                <option value="project_admin">Project Admin</option>
                <option value="surveyor">Surveyor</option>
              </select>
            </Grid>
            {!isProjectAdmin && (
              <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  onClick={() => setIsAddUserOpen(true)}
                  className="add-user-btn"
                >
                  Add User
                </Button>
              </Grid>
            )}
          </Grid>
        </div>
        {/* Table */}
        <div className="table-container">
          {loading ? (
            <div className="loading-state">Loading users...</div>
          ) : error ? (
            <div className="error-state">Failed to load users. Please try again.</div>
          ) : (
            <table className="users-table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Organization</th> {/* Changed from Projects */}
                  <th>Last Login</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((u) => (
                  <tr key={u.id}>
                    <td>
                      <div className="user-info">
                        <div className="user-avatar" style={{ backgroundColor: "#3b82f6" }}>
                          {u.profile_picture ? (
                            <img src={u.profile_picture} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }} />
                          ) : (
                            u.full_name?.slice(0, 2).toUpperCase() || "??"
                          )}
                        </div>
                        <div className="user-details">
                          <div className="user-name">{u.full_name}</div>
                          <div className="user-email">{u.email}</div>
                        </div>
                      </div>
                    </td>
                    <td>{formatRole(u.role)}</td>
                    <td>{u.is_active ? "Active" : "Inactive"}</td>
                    <td>{u.organization_name || 'N/A'}</td> {/* Changed from u.projects */}
                    <td>{u.last_login}</td>
                    <td>
                      <IconButton onClick={() => { setSelectedUserId(u.id); setIsEditUserOpen(true); }}>
                        <Edit size={20} color="#10b981" />
                      </IconButton>
                      <IconButton onClick={() => { setSelectedUserId(u.id); setIsViewUserOpen(true); }}>
                        <Eye size={20} color="#06b6d4" />
                      </IconButton>
                      <IconButton onClick={() => { setUserToDelete(u.id); setIsDeleteDialogOpen(true); }}>
                        <Trash size={20} color="red" />
                      </IconButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
       {/* Pagination + Rows per page – using classes from your CSS */}
        {totalCount > 0 && (
          <div className="pagination-section">
            <div className="pagination-info">
              Showing {showingFrom} – {showingTo} of {totalCount}
            </div>
            <div className="pagination-controls">
              {/* Rows per page selector */}
              <select
                className="page-size-select"
                value={entriesPerPage}
                onChange={(e) => {
                  setEntriesPerPage(Number(e.target.value));
                  setCurrentPage(1); // reset to first page
                }}
              >
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={20}>20</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              {/* Navigation buttons */}
              <button
                className="pagination-btn"
                disabled={currentPage === 1 || loading}
                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              >
                Previous
              </button>
              <button
                className="pagination-btn"
                disabled={currentPage >= (pagination?.total_pages || 1) || loading}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Next
              </button>
            </div>
          </div>
        )}
        {/* Dialogs */}
        {!isProjectAdmin && (
          <FormDialog
            open={isAddUserOpen}
            onClose={() => setIsAddUserOpen(false)}
            title="Add New User"
            fields={baseFields}
            initialValues={{ status: "active" }}
            onSubmit={handleAddUserSubmit}
            submitLabel="Create User"
          />
        )}
       <FormDialog
          open={isEditUserOpen}
          onClose={() => setIsEditUserOpen(false)}
          title="Edit User"
          fields={editFields}
          initialValues={editInitialValues}
          onSubmit={(data) => handleEditUserSubmit(data, editInitialValues)} // Pass initial for diff
          profileImage={selectedUser.profile_picture}
          profileName={selectedUser.full_name}
          showProfileEdit={false}
          editMode={true}
        />
         <FormDialog
            open={isViewUserOpen}
            onClose={() => setIsViewUserOpen(false)}
            title="User Details"
            fields={viewUserFields}
            initialValues={selectedUser}
            viewMode
            submitLabel="Close"
            cancelLabel="Close"
            profileImage={selectedUser.profile_picture}
            profileName={selectedUser.full_name}
          />
        <Dialog open={isDeleteDialogOpen} onClose={() => setIsDeleteDialogOpen(false)}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this user? This action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setIsDeleteDialogOpen(false)}>Cancel</Button>
            <Button
              color="error"
              onClick={async () => {
                try {
                  await deleteUser(userToDelete);
                  refetch();
                  setIsDeleteDialogOpen(false);
                } catch (err) {
                  // alert("Delete failed");
                }
              }}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </form>
  );
};

export default UserManagement;